var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternationalBrandsService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 132.686,
    viewBox: "0 0 250 132.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(-992.229 -657.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M1200.191,693.822v29.614h66.278V693.822a2.92,2.92,0,0,0-2.92-2.92H1203.11A2.92,2.92,0,0,0,1200.191,693.822Zm31.485,4.76a1.654,1.654,0,0,1,1.654-1.654h0a1.654,1.654,0,0,1,1.655,1.654V700.8a1.655,1.655,0,0,1-1.655,1.655h0a1.655,1.655,0,0,1-1.654-1.655Z",
    transform: "translate(-44.089 -7.073)",
    fill: "#595958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1065",
    "data-name": "Rectangle 1065",
    d: "M3.2,0H64.6a0,0,0,0,1,0,0V87.918a0,0,0,0,1,0,0H3.2a3.2,3.2,0,0,1-3.2-3.2V3.2A3.2,3.2,0,0,1,3.2,0Z",
    transform: "translate(1242.229 790.225) rotate(-180)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 33.284,
    height: 68.325,
    transform: "translate(1219.547 779.853) rotate(-180)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 0.594,
    height: 68.325,
    transform: "translate(1219.547 779.853) rotate(-180)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M1238.467,729.831l33.284,14.6v5.864l-33.284-14.666Z",
    transform: "translate(-52.204 -15.326)",
    fill: "#ccc",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M1238.467,756.5l33.284,14.6v5.864l-33.284-14.666Z",
    transform: "translate(-52.204 -20.979)",
    fill: "#ccc",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M1238.467,739.43l33.284,14.6v2.5l-33.284-14.666Z",
    transform: "translate(-52.204 -17.361)",
    fill: "#ccc",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M1238.467,775.694l33.284,14.6v2.5l-33.284-14.666Z",
    transform: "translate(-52.204 -25.049)",
    fill: "#ccc",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1068",
    "data-name": "Rectangle 1068",
    width: 2.662,
    height: 87.918,
    transform: "translate(1230.534 790.225) rotate(-180)",
    fill: "#ffd525"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1069",
    "data-name": "Rectangle 1069",
    width: 2.662,
    height: 87.918,
    transform: "translate(1235.576 790.225) rotate(-180)",
    fill: "#ffd525"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 21.53,
    height: 87.918,
    transform: "translate(1177.632 790.225) rotate(-180)",
    fill: "#6b6b6a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465",
    transform: "translate(1017.03 657.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M1069.4,699.107h-2.492V671.238a11.206,11.206,0,0,0-22.412,0v27.869h-2.492V671.238a13.7,13.7,0,0,1,27.4,0Z",
    transform: "translate(-1027.583 -657.54)",
    fill: "#28a00a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    d: "M0,0H37.042a0,0,0,0,1,0,0V101.347a0,0,0,0,1,0,0H2.943A2.943,2.943,0,0,1,0,98.4V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 31.298)",
    fill: "#5dc40c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1072",
    "data-name": "Rectangle 1072",
    width: 81.388,
    height: 101.347,
    transform: "translate(19.022 31.298)",
    fill: "#5dc40c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1073",
    "data-name": "Rectangle 1073",
    width: 18.02,
    height: 101.347,
    transform: "translate(19.022 31.298)",
    fill: "#28a00a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M1118.409,699.107h-2.492V671.238a11.206,11.206,0,0,0-22.412,0v27.869h-2.492V671.238a13.7,13.7,0,0,1,27.4,0Z",
    transform: "translate(-1037.973 -657.54)",
    fill: "#28a00a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_558",
    "data-name": "Ellipse 558",
    cx: 2.278,
    cy: 2.278,
    r: 2.278,
    transform: "translate(52.011 39.702)",
    fill: "#28a00a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_559",
    "data-name": "Ellipse 559",
    cx: 2.278,
    cy: 2.278,
    r: 2.278,
    transform: "translate(76.912 39.288)",
    fill: "#28a00a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467",
    transform: "translate(1086.495 674.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M1126.585,704.668h-12.541a2.188,2.188,0,0,0-2.177,2.411l3.418,33.208a2.95,2.95,0,0,0,2.934,2.648h11.814Z",
    transform: "translate(-1111.856 -684.287)",
    fill: "#bc5006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M1176.323,748.126l.443-6.484h-61.4l.667,6.484a2.958,2.958,0,0,0,2.674,2.648h54.784A2.842,2.842,0,0,0,1176.323,748.126Z",
    transform: "translate(-1112.599 -692.126)",
    fill: "#993a14",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466",
    transform: "translate(11.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M1152.384,678.8h0v.005c4.973,0,9.42,3.116,12.59,8.149a34.7,34.7,0,0,1,4.837,16.1h-2.994a31.534,31.534,0,0,0-4.374-14.508c-2.627-4.173-6.188-6.755-10.058-6.755v0h0v0c-3.868,0-7.43,2.582-10.056,6.753a31.546,31.546,0,0,0-4.372,14.51h-3a34.657,34.657,0,0,1,4.837-16.1c3.17-5.033,7.616-8.146,12.587-8.148V678.8Z",
    transform: "translate(-1127.907 -678.804)",
    fill: "#dd691b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M1189.507,740.286l2.276-33.361a2.114,2.114,0,0,0-2.109-2.257H1126.01l2.465,36.159a2.262,2.262,0,0,0,2.256,2.108h55.94A2.842,2.842,0,0,0,1189.507,740.286Z",
    transform: "translate(-1126.01 -684.287)",
    fill: "#e25b00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M1190.042,748.126l.443-6.484h-61.954l.48,7.046a2.238,2.238,0,0,0,2.233,2.086h55.962A2.842,2.842,0,0,0,1190.042,748.126Z",
    transform: "translate(-1126.544 -692.126)",
    fill: "#8c3002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M1166.387,678.8h0v.005c4.973,0,9.42,3.116,12.59,8.149a33.967,33.967,0,0,1,4.7,14.43,1.5,1.5,0,0,1-1.485,1.674h0a1.5,1.5,0,0,1-1.487-1.364,30.893,30.893,0,0,0-4.256-13.144c-2.626-4.173-6.188-6.755-10.058-6.755v0h0v0c-3.869,0-7.43,2.582-10.057,6.753a30.9,30.9,0,0,0-4.254,13.145,1.5,1.5,0,0,1-1.487,1.365h0a1.5,1.5,0,0,1-1.485-1.674,33.933,33.933,0,0,1,4.7-14.431c3.17-5.033,7.617-8.146,12.587-8.148V678.8Z",
    transform: "translate(-1130.904 -678.804)",
    fill: "#f9751c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M1144.364,713.333h-1.218l.861-.862a.276.276,0,1,0-.39-.389l-.862.861v-1.219a.275.275,0,0,0-.551,0v1.219l-.861-.861a.276.276,0,0,0-.391.389l.862.862H1140.6a.276.276,0,1,0,0,.552h1.219l-.862.861a.276.276,0,0,0,.391.39l.861-.861v1.218a.275.275,0,1,0,.551,0v-1.218l.862.861a.276.276,0,1,0,.39-.39l-.861-.861h1.218a.276.276,0,1,0,0-.552Z",
    transform: "translate(-1117.891 -685.725)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M1160.543,713.333h-1.217l.861-.862a.276.276,0,1,0-.39-.389l-.861.861v-1.219a.276.276,0,0,0-.552,0v1.219l-.861-.861a.276.276,0,0,0-.391.389l.862.862h-1.219a.276.276,0,0,0,0,.552h1.219l-.862.861a.276.276,0,0,0,.391.39l.861-.861v1.218a.276.276,0,1,0,.552,0v-1.218l.861.861a.276.276,0,1,0,.39-.39l-.861-.861h1.217a.276.276,0,1,0,0-.552Z",
    transform: "translate(-1121.321 -685.725)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M1176.723,713.333H1175.5l.862-.862a.276.276,0,0,0-.391-.389l-.861.861v-1.219a.276.276,0,0,0-.552,0v1.219l-.861-.861a.276.276,0,0,0-.391.389l.862.862h-1.218a.276.276,0,1,0,0,.552h1.218l-.862.861a.276.276,0,0,0,.391.39l.861-.861v1.218a.276.276,0,0,0,.552,0v-1.218l.861.861a.276.276,0,0,0,.391-.39l-.862-.861h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1124.751 -685.725)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M1192.9,713.333h-1.218l.862-.862a.276.276,0,0,0-.391-.389l-.861.861v-1.219a.275.275,0,0,0-.551,0v1.219l-.862-.861a.276.276,0,0,0-.39.389l.861.862h-1.218a.276.276,0,1,0,0,.552h1.218l-.861.861a.276.276,0,0,0,.39.39l.862-.861v1.218a.275.275,0,1,0,.551,0v-1.218l.861.861a.276.276,0,0,0,.391-.39l-.862-.861h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1128.181 -685.725)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M1152.454,722.455h-1.218l.862-.861a.276.276,0,0,0-.391-.39l-.861.861v-1.218a.276.276,0,1,0-.552,0v1.218l-.861-.861a.276.276,0,1,0-.39.39l.861.861h-1.218a.276.276,0,0,0,0,.552h1.218l-.861.862a.276.276,0,0,0,0,.389.275.275,0,0,0,.39,0l.861-.861v1.218a.276.276,0,1,0,.552,0V723.4l.861.861a.276.276,0,0,0,.391-.389l-.862-.862h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1119.606 -687.659)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M1168.633,722.455h-1.218l.862-.861a.276.276,0,0,0-.39-.39l-.862.861v-1.218a.275.275,0,1,0-.551,0v1.218l-.862-.861a.276.276,0,1,0-.39.39l.861.861h-1.218a.276.276,0,0,0,0,.552h1.218l-.861.862a.276.276,0,0,0,.2.47.273.273,0,0,0,.195-.081l.862-.861v1.218a.275.275,0,1,0,.551,0V723.4l.862.861a.275.275,0,0,0,.39,0,.276.276,0,0,0,0-.389l-.862-.862h1.218a.276.276,0,1,0,0-.552Z",
    transform: "translate(-1123.036 -687.659)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M1184.812,722.455h-1.218l.861-.861a.276.276,0,0,0-.39-.39l-.861.861v-1.218a.276.276,0,1,0-.552,0v1.218l-.861-.861a.276.276,0,0,0-.391.39l.862.861h-1.219a.276.276,0,1,0,0,.552h1.219l-.862.862a.276.276,0,1,0,.391.389l.861-.861v1.218a.276.276,0,1,0,.552,0V723.4l.861.861a.276.276,0,1,0,.39-.389l-.861-.862h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1126.466 -687.659)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M1200.991,722.455h-1.217l.862-.861a.276.276,0,1,0-.391-.39l-.861.861v-1.218a.276.276,0,1,0-.552,0v1.218l-.861-.861a.276.276,0,0,0-.391.39l.862.861h-1.218a.276.276,0,1,0,0,.552h1.218l-.862.862a.276.276,0,1,0,.391.389l.861-.861v1.218a.276.276,0,1,0,.552,0V723.4l.861.861a.276.276,0,1,0,.391-.389l-.862-.862h1.217a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1129.896 -687.659)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M1145.157,732.173h-1.218l.861-.861a.276.276,0,0,0-.39-.39l-.861.861v-1.218a.276.276,0,0,0-.552,0v1.218l-.861-.861a.276.276,0,0,0-.391.39l.862.861h-1.219a.276.276,0,0,0,0,.552h1.219l-.862.862a.276.276,0,0,0,.391.389l.861-.861v1.219a.276.276,0,0,0,.552,0v-1.219l.861.861a.275.275,0,0,0,.39,0,.276.276,0,0,0,0-.389l-.861-.862h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1118.059 -689.719)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M1161.337,732.173h-1.218l.862-.861a.276.276,0,0,0-.391-.39l-.861.861v-1.218a.276.276,0,0,0-.552,0v1.218l-.861-.861a.276.276,0,0,0-.391.39l.862.861h-1.218a.276.276,0,0,0,0,.552h1.218l-.862.862a.276.276,0,0,0,.2.47.273.273,0,0,0,.2-.081l.861-.861v1.219a.276.276,0,0,0,.552,0v-1.219l.861.861a.276.276,0,0,0,.391-.389l-.862-.862h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1121.489 -689.719)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M1177.516,732.173H1176.3l.862-.861a.276.276,0,0,0-.391-.39l-.861.861v-1.218a.275.275,0,1,0-.551,0v1.218l-.862-.861a.276.276,0,0,0-.39.39l.861.861h-1.218a.276.276,0,0,0,0,.552h1.218l-.861.862a.276.276,0,0,0,0,.389.275.275,0,0,0,.39,0l.862-.861v1.219a.275.275,0,0,0,.551,0v-1.219l.861.861a.276.276,0,0,0,.391-.389l-.862-.862h1.218a.276.276,0,0,0,0-.552Z",
    transform: "translate(-1124.919 -689.719)",
    fill: "#ff8533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M1193.695,732.173h-1.217l.861-.861a.276.276,0,0,0-.39-.39l-.862.861v-1.218a.275.275,0,1,0-.551,0v1.218l-.861-.861a.276.276,0,1,0-.391.39l.862.861h-1.219a.276.276,0,0,0,0,.552h1.219l-.862.862a.276.276,0,0,0,0,.389.276.276,0,0,0,.391,0l.861-.861v1.219a.275.275,0,0,0,.551,0v-1.219l.862.861a.275.275,0,0,0,.39,0,.276.276,0,0,0,0-.389l-.861-.862h1.217a.276.276,0,1,0,0-.552Z",
    transform: "translate(-1128.349 -689.719)",
    fill: "#ff8533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(1088.125 732.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1074",
    "data-name": "Rectangle 1074",
    d: "M0,0H33.679a0,0,0,0,1,0,0V57.283a0,0,0,0,1,0,0H2.58A2.58,2.58,0,0,1,0,54.7V0A0,0,0,0,1,0,0Z",
    transform: "translate(1.999)",
    fill: "#6f38d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    d: "M2.269,0H35.678a0,0,0,0,1,0,0V10.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.269A2.269,2.269,0,0,1,2.269,0Z",
    fill: "#47206d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1076",
    "data-name": "Rectangle 1076",
    d: "M0,0H62.46a0,0,0,0,1,0,0V54.7a2.58,2.58,0,0,1-2.58,2.58H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(35.678)",
    fill: "#9a4dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M1150.142,756.633h-33.679v10.9H1212.6v-10.9Z",
    transform: "translate(-1114.464 -753.951)",
    fill: "#491e72",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1077",
    "data-name": "Rectangle 1077",
    d: "M0,0H62.327A2.269,2.269,0,0,1,64.6,2.269V10.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(35.678)",
    fill: "#572680"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    transform: "translate(992.229 731.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M993.92,797.177a3.773,3.773,0,0,1-1.641-3.625c.367-2.206,3.611-6.7,11.8-6.811a2.722,2.722,0,0,1,2.126.935c1.717,2.051,5.067,2.557,8.589,2.136,7.061-.845,12.445-12.953,13.881-16.7,2.1-5.482,5.227-12.263,10.619-17.508,4.82-4.689,5.517-4.034,5.517-4.034a16.415,16.415,0,0,1,6.339,16.605c-.865,4.654-3.252,11.446-6.377,9.861a26.928,26.928,0,0,0-3.2-1.284l-5.8,4.5-5.139,6.38-6.3,11.77-8.248,2.563Z",
    transform: "translate(-992.229 -751.543)",
    fill: "#e25d4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M1050.039,776.234a32.815,32.815,0,0,0,1.111-4.316,18.723,18.723,0,0,0,.309-2.742c-5.265,1.389-10.545,5.778-15.393,10.5-5.872,5.71-13.488,26.039-31.891,19.813-3.339-1.128-7.508-2.439-10.848-4.457a5.62,5.62,0,0,0-1.047,2.263,3.773,3.773,0,0,0,1.641,3.625l22.165,4.8,8.248-2.563,6.3-11.77,5.139-6.38,5.8-4.5S1048.842,779.8,1050.039,776.234Z",
    transform: "translate(-992.229 -755.282)",
    fill: "#d8422a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M992.23,799.276s12.018,5.8,24.12,5.967c5.415-.175,7.706-2.9,9.116-6.132a63.047,63.047,0,0,1,9.613-14.588c4.05-4.321,12.378-10.288,16.161-11.77.24,1.391-.29,4.663-.943,7.992-.48,2.435-2.121,14.344-2.384,19.846-.3,6.261-.484,13.522-.484,13.522a17.37,17.37,0,0,1-4.891.5c0-4.64.095-29.245-.663-30.086s-1.823-.828-4.475,1.574-8.029,7.905-10.952,20.835c-1.517,6.463-5.256,7.108-6.83,7.439s-22.25-1.006-26.394-5.482C992.23,805.659,992.23,799.276,992.23,799.276Z",
    transform: "translate(-992.229 -756.04)",
    fill: "#bc2f13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M1041.35,786.468c-.926,0-2,.461-3.688,1.987-1.969,1.786-8.794,7.3-11.934,21.178-1.017,4.334-4.2,6.625-6.872,6.874-2.514.234-20.217-1.674-25.525-5.168.042.159.084.313.127.459,4.144,4.476,24.917,6.051,26.492,5.719s5.215-1.214,6.732-7.677c2.923-12.93,8.3-18.43,10.951-20.835s3.716-2.414,4.475-1.574.663,25.446.663,30.086c.314,0,.606,0,.886-.013.007-.108.012-.214.014-.329v-.954c.023-19.2-.756-25.7-.88-27.947C1042.719,786.924,1041.887,786.468,1041.35,786.468Z",
    transform: "translate(-992.463 -758.948)",
    fill: "#b51d04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M1061.01,823.163a24.459,24.459,0,0,1-4.936.5c0,.673,0,1.228,0,1.631h4.885S1060.979,824.183,1061.01,823.163Z",
    transform: "translate(-1005.765 -766.727)",
    fill: "#b51d04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M992.254,800.635c3.068,1.346,13.431,5.695,23.6,5.834a10.967,10.967,0,0,0,10.189-7.1,52.353,52.353,0,0,1,24.934-25.178c.1-.047.206-.086.307-.127a6.469,6.469,0,0,0-.049-1.308c-3.783,1.482-12.111,7.449-16.161,11.77a63.047,63.047,0,0,0-9.613,14.588c-1.41,3.231-3.7,5.957-9.116,6.132-12.1-.164-24.12-5.967-24.12-5.967s0,.53.024,1.359Z",
    transform: "translate(-992.229 -756.04)",
    fill: "#ff8c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M998.117,800.523s2.7-2.246,5.237-1.8c1.587,1.318,4.047,2.114,7.459,2.908C1006.448,803.537,998.117,800.523,998.117,800.523Z",
    transform: "translate(-993.478 -761.534)",
    fill: "#ff8c71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471",
    transform: "translate(1008.198 731.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M1014.185,797.177a3.773,3.773,0,0,1-1.641-3.625c.367-2.206,3.611-6.7,11.8-6.811a2.722,2.722,0,0,1,2.126.935c1.717,2.051,5.067,2.557,8.589,2.136,7.061-.845,12.445-12.953,13.881-16.7,2.1-5.482,5.227-12.263,10.619-17.508,4.82-4.689,5.517-4.034,5.517-4.034a16.417,16.417,0,0,1,6.34,16.605c-.866,4.654-3.253,11.446-6.378,9.861a26.921,26.921,0,0,0-3.2-1.284l-5.8,4.5-5.139,6.38-6.3,11.77-8.248,2.563Z",
    transform: "translate(-1012.494 -751.543)",
    fill: "#f16a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M1070.3,776.234a32.977,32.977,0,0,0,1.112-4.316,18.835,18.835,0,0,0,.308-2.742c-5.265,1.389-10.545,5.778-15.393,10.5-5.872,5.71-13.488,26.039-31.891,19.813-3.339-1.128-7.508-2.439-10.847-4.457a5.613,5.613,0,0,0-1.048,2.263,3.773,3.773,0,0,0,1.641,3.625l22.165,4.8,8.248-2.563,6.3-11.77,5.139-6.38,5.8-4.5S1069.108,779.8,1070.3,776.234Z",
    transform: "translate(-1012.494 -755.282)",
    fill: "#f4502a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M1012.495,799.276s12.018,5.8,24.12,5.967c5.415-.175,7.706-2.9,9.116-6.132a63.047,63.047,0,0,1,9.613-14.588c4.05-4.321,12.378-10.288,16.161-11.77.24,1.391-.29,4.663-.943,7.992-.48,2.435-2.121,14.344-2.384,19.846-.3,6.261-.484,13.522-.484,13.522a17.37,17.37,0,0,1-4.891.5c0-4.64.095-29.245-.663-30.086s-1.823-.828-4.474,1.574-8.03,7.905-10.952,20.835c-1.517,6.463-5.256,7.108-6.83,7.439s-22.25-1.006-26.394-5.482C1012.495,805.659,1012.495,799.276,1012.495,799.276Z",
    transform: "translate(-1012.494 -756.04)",
    fill: "#e8390a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M1061.615,786.468c-.926,0-2,.461-3.688,1.987-1.969,1.786-8.794,7.3-11.934,21.178-1.017,4.334-4.2,6.625-6.872,6.874-2.514.234-20.217-1.674-25.525-5.168.042.159.084.313.127.459,4.144,4.476,24.917,6.051,26.492,5.719s5.215-1.214,6.732-7.677c2.923-12.93,8.3-18.43,10.952-20.835s3.715-2.414,4.474-1.574.663,25.446.663,30.086c.314,0,.606,0,.886-.013.007-.108.012-.214.014-.329v-.954c.023-19.2-.756-25.7-.88-27.947C1062.984,786.924,1062.152,786.468,1061.615,786.468Z",
    transform: "translate(-1012.728 -758.948)",
    fill: "#b51d04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M1081.275,823.163a24.457,24.457,0,0,1-4.935.5c0,.673,0,1.228,0,1.631h4.885S1081.244,824.183,1081.275,823.163Z",
    transform: "translate(-1026.03 -766.727)",
    fill: "#b51d04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M1012.519,800.635c3.068,1.346,13.431,5.695,23.6,5.834a10.967,10.967,0,0,0,10.189-7.1,52.361,52.361,0,0,1,24.934-25.178c.1-.047.206-.086.307-.127a6.478,6.478,0,0,0-.049-1.308c-3.783,1.482-12.111,7.449-16.161,11.77a63.047,63.047,0,0,0-9.613,14.588c-1.41,3.231-3.7,5.957-9.116,6.132-12.1-.164-24.12-5.967-24.12-5.967s0,.53.024,1.359Z",
    transform: "translate(-1012.494 -756.04)",
    fill: "#ff8c71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M1018.382,800.523s2.7-2.246,5.237-1.8c1.587,1.318,4.047,2.114,7.459,2.908C1026.714,803.537,1018.382,800.523,1018.382,800.523Z",
    transform: "translate(-1013.743 -761.534)",
    fill: "#ff8c71"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M1180.711,790.876s-2.654,10.066,6.125,10.9c5.54.529,12.934-9.986,23.089-16.414C1196.9,788.347,1185.183,804.866,1180.711,790.876Z",
    transform: "translate(-39.879 -27.1)",
    fill: "#6f38d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M1130.8,753.231a4.542,4.542,0,1,0,9.083,0Z",
    transform: "translate(-29.378 -20.287)",
    fill: "#6f38d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalBrandsService);
export default __webpack_public_path__ + "static/media/International-brands-service.272204762759f85c3753aba61e6681f7.svg";
export { ForwardRef as ReactComponent };